import { useContext } from "react";
import { useHistory } from "react-router-dom";
import style from "./style.module.scss";
import { langContext } from "commons/contexts";


type textType = { [key: string]: { [key: string]: string } };

const titles: textType = {
    "nl": { purchases: "AANKOPEN", region: "REGIO", lifestyle: "LIFESTYLE", news: "NIEUWS" },
    "fr": { purchases: "ACHETER", region: "REGION", lifestyle: "STYLE DE VIE", news: "INFO" }
}
const text: textType = {
    nl: {
        title1: "Alles weten in een oogopslag",
        title2: "Klaar voor je droomproject? Hier wordt je goed geinformeerd."
    },
    fr: {
        title1: "Tout savoir en un coup d'œil!",
        title2: "Prêt pour le projet de vos rêves ? Ici, vous serez bien informé."
    }
}
function PagesPart() {

    const { lang } = useContext(langContext);

    const pageData = [
        { image: "media/images/frontpage/pagespart/1.jpg", title: titles[lang]?.purchases, news: "news/purchases" },
        { image: "media/images/frontpage/pagespart/2.jpg", title: titles[lang]?.region, news: "news/region" },
        { image: "media/images/frontpage/pagespart/3.jpg", title: titles[lang]?.lifestyle, news: "news/lifestyle" },
        { image: "media/images/frontpage/pagespart/4.jpg", title: titles[lang]?.news, news: "news" }
    ];


    return (
        <div className={style.root}>
            <div className={style.titlePart}>
                <div>{text[lang]?.title1 || ""}</div>
                <div>{text[lang]?.title2 || ""}</div>
            </div>

            <div className={style.pagesGrid}>
                {pageData.map((data, i) => <PageItem data={data} key={i} number={i + 1} news={data.news} />)}
            </div>
        </div>
    )
}

interface props {
    data: { [key: string]: any };
    number: number;
    news: string;
}
function PageItem({ data, number, news }: props) {
    const { lang } = useContext(langContext);
    const history = useHistory();

    const { image, title } = data;
    return (
        <div className={style.pageItem} onClick={e => history.push("/" + lang + "/" + news)} style={{ backgroundImage: `url("${image}")` }}>
            <div> {"0" + number} </div>
            <div> {title} </div>
        </div>
    );
}

export default PagesPart;